import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterOutlet, RouterLink } from '@angular/router';
import { AuthService } from '../../services/auth.service';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';
import { MatDividerModule } from '@angular/material/divider';
import { FooterSectionComponent } from '../footer-section/footer-section.component';

@Component({
  selector: 'app-main-layout',
  standalone: true,
  imports: [
    CommonModule, 
    RouterOutlet, 
    RouterLink, 
    MatToolbarModule,
    MatIconModule,
    MatButtonModule,
    MatMenuModule,
    MatDividerModule,
    MatTooltipModule,
    FooterSectionComponent
  ],
  templateUrl: './main-layout.component.html'
})
export class MainLayoutComponent implements OnInit {
  menuItems: any[] = [];
  allMenuItems = [
    {
      icon: 'dashboard',
      label: 'Dashboard',
      route: '/dashboard',
      roles: ['superadmin', 'admin', 'csr', 'users', 'user'],
    },
    {
      icon: 'credit_card',
      label: 'My vCards',
      route: '/cards',
      roles: ['superadmin', 'admin', 'csr', 'users', 'user'],
    },
    {
      icon: 'analytics',
      label: 'Analytics',
      route: '/analytics',
      roles: ['superadmin', 'admin', 'csr', 'users', 'user'],
    },
  ];

  constructor(
    public authService: AuthService,
    private router: Router
  ) {}

  async ngOnInit() {
    await new Promise(resolve => setTimeout(resolve, 100));
    
    const user = this.authService.currentUser;
    
    if (!user) {
      this.router.navigate(['/login']);
      return;
    }
    
    const userRole = user.role || 'user';
    const validRoles = ['superadmin', 'admin', 'csr', 'users', 'user'];
    
    if (!validRoles.includes(userRole)) {
      this.router.navigate(['/unauthorized']);
      return;
    }
    
    this.menuItems = this.allMenuItems.filter((item) =>
      item.roles.includes(userRole)
    );
  }

  logout() {
    this.authService.signOut();
  }
}
